// extracted by mini-css-extract-plugin
module.exports = {"educatorResponse":"styles_educatorResponse__1_Vkn","header":"styles_header__UYPlv","educatorName":"styles_educatorName__EeSV3","date":"styles_date__TWsgM"};